import { PortfolioTitle } from "../../../Constant";
import { H4, P, Image } from "../../../AbstractElements";
import PagesSort from "./Pages";
import React, { Fragment, useMemo, useState } from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import Lightbox from "react-18-image-lightbox";

const PhotosTab = () => {
  const description = "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
  const defaultLargeImages = useMemo(
    () => [
      "big-lightgallry/01.jpg",
      "big-lightgallry/02.jpg",
      "big-lightgallry/03.jpg",
      "big-lightgallry/04.jpg",
    ],
    []
  );
  const defaultSmallImages = useMemo(
    () => [
      "lightgallry/01.jpg",
      "lightgallry/02.jpg",
      "lightgallry/03.jpg",
      "lightgallry/04.jpg",
    ],
    []
  );
  const [imagess] = useState(defaultLargeImages);
  const [smallImages] = useState(defaultSmallImages);
  const initilindex = { index: 0, isOpen: false };
  const [photoIndex, setPhotoIndex] = useState(initilindex);

  const onMovePrev = () => {
    const prev = (photoIndex.index + imagess.length - 1) % imagess.length;
    setPhotoIndex({ ...photoIndex, index: prev });
  };

  const onMoveNext = () => {
    const next = (photoIndex.index + 1) % imagess.length;
    setPhotoIndex({ ...photoIndex, index: next });
  };

  var images = require.context("../../../assets/images", true);
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };
  return (
    <Fragment>
      <Row>
        {smallImages && (
          <Col sm="12">
            <Card>
              <CardBody className="my-gallery row gallery-with-description">
                {smallImages &&
                  smallImages.map((item, i) => {
                    return (
                      <figure className="col-xl-3 col-sm-6" key={i}>
                        <a href="#javascript" data-size="1600x950">
                          <Image
                            attrImage={{
                              src: `${dynamicImage(item)}`,
                              alt: "Gallery",
                              className: "img-thumbnail",
                              onClick: () => setPhotoIndex({ ...photoIndex, index: 1, isOpen: true }),
                            }}
                          />
                          <div className="caption">
                            <H4>{PortfolioTitle}</H4>
                            <P>{description}</P>
                          </div>
                        </a>
                      </figure>
                    );
                  })}
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
      <PagesSort />
      {photoIndex.isOpen && (
        <Lightbox mainSrc={require(`../../../assets/images/${imagess[photoIndex.index]}`)} nextSrc={require(`../../../assets/images/${imagess[(photoIndex.index + 1) % imagess.length]}`)} prevSrc={require(`../../../assets/images/${imagess[(photoIndex.index + imagess.length - 1) % imagess.length]}`)} imageTitle={photoIndex.index + 1 + "/" + imagess.length} onCloseRequest={() => setPhotoIndex({ ...photoIndex, isOpen: false })} onMovePrevRequest={onMovePrev} onMoveNextRequest={onMoveNext} />
      )}
    </Fragment>
  );
};

export default PhotosTab;
